import { render, staticRenderFns } from "./MainPublic.vue?vue&type=template&id=a02f5d4a&lang=pug"
import script from "./MainPublic.vue?vue&type=script&lang=js"
export * from "./MainPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports